import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Behfa_Interface } from 'src/app/Interface/Behfa_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BehfaService {

  constructor(private http:HttpClient) { }

  GetRecord():Observable<Array<Behfa_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Behfa").pipe(
      map(data=>{
        return data as Array<Behfa_Interface>
      })
    )
  }

  GetSingle(id:number):Observable<Behfa_Interface>{
    return this.http.get(environment.BaseUrl + "Daro/Behfa/GetSingle?id="+id).pipe(
      map(data=>{
        return data as Behfa_Interface
      })
    )
  }

  AddEditBehfa(model: Behfa_Interface):Observable<Behfa_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body={
      id:model.id,
      val:model.val+'',
      type:model.type,
      create_user: ''
    }

    return this.http.post(environment.BaseUrl + "Daro/Behfa/AddEdit",body,{headers}).pipe(
      map(data=>{
        return data as Behfa_Interface
      })
    )
  }

  DeleteBehfa(id:number):Observable<Behfa_Interface>{

    return this.http.get(environment.BaseUrl + "Daro/Behfa/Delete?id="+id).pipe(
      map(data=>{
        return data as Behfa_Interface
      })
    )
  }

  PriorityBehfa(id:number):Observable<Behfa_Interface>{

    return this.http.get(environment.BaseUrl + "Daro/Behfa/Priority?id="+id).pipe(
      map(data=>{
        return data as Behfa_Interface
      })
    )
  }

  uploadFile(body){

    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/Behfa/Upload", body).pipe(
      map(data=>{

        return data
      })
    )
  }


}
